
<header>

  <div class="container" style="position: relative">
    <div class="header-image">
      <img src="/assets/img/logo.png" alt="main logo">
    </div>
    <nav [ngClass]="{'menu-open' : !menuOpen}">
      <ul>
        <li class="mobile-logo"><img src="/assets/img/logo.png" alt="main logo"></li>
        <li routerLink="/home" class="piano-key--animated"><a routerLink="/home">Home</a></li>
        <li routerLink="/tuning" class="piano-key--animated"><a routerLink="/tuning">Tuning</a></li>
        <li routerLink="/case-finishing" class="piano-key--animated"><a>Case Finishing</a></li>
        <li routerLink="/restorations" class="piano-key--animated"><a>Restoration</a></li>
        <li routerLink="/hire" class="piano-key--animated"><a>Other Services</a></li>
        <li routerLink="/for-sale" class="piano-key--animated"><a>For Sale</a></li>
        <li routerLink="/news" class="piano-key--animated"><a>News</a></li>
      </ul>
    </nav>
  </div>


</header>
<div class="menu-opener" (click)="menuOpen = !menuOpen">
  <div class="burger" [ngClass]="{'burger-open' : menuOpen}"></div>
</div>
<div class="edit-menu">
  @if (afAuth.user | async; as user) {
    <div>
      <p>Hello {{ user.displayName }}!</p>
      <button class="button" (click)="logout()">Logout</button>
    </div>
  }
  @if (afAuth.user | async) {
    <button class="button btn--edit-home"
      (click)="toggleEditMode()">
      Edit mode toggle
    </button>
  }
</div>



